import { useSelector } from 'react-redux';

import useApi from '../useApi';
import { useShowToast } from '../useShowToast';

export const useFetchDsps = () => {
  const user = useSelector((state) => state.user);

  const showToast = useShowToast();

  const { data, error, loading, postData: fetchDsps } = useApi('/BlazorApi/dspsfulldata');

  const fetchDsp = async (filters) => {
    const dspsBody = {
      id: user?.roleId === 1 ? 0 : user?.dspId == '' ? 0 : user?.dspId,
      name: '',
      address: '',
      contact: '',
      email: '',
      rowVer: 0,
      ...filters,
    };
    const res = await fetchDsps(dspsBody);
    if (res) {
      if (res?.data?.status) {
        return res.data.data;
      } else {
        showToast(res.data?.message, 'error');
        return [];
      }
    } else {
      return [];
    }
  };

  return { data, error, loading, fetchDsp };
};
